import DataService from './data-service';
import axios, { API_URL } from './http-service';

interface LogQuery {
  year: string | number;
  month: string | number;
  day?: string | number;
  interval?: string | number;
}

export default class LogService extends DataService {

  findByDeviceId = async (deviceId: string, query?: LogQuery, showMonth?: boolean) => {
    let url = API_URL + '/logs/' + deviceId;
    if (query) {
      if (showMonth === true) {
        query.day = '';
      }
      url += `?year=${query.year}&month=${query.month}`;
      if (query.day) url += `&day=${query.day}`;
      if (query.interval) url += `&interval=${query.interval}`;
    }
    return this.handler(() => axios.get(url));
  }

}
